import React, { useRef } from "react";
import { Button, Input } from "antd";
import "./style.scss";

interface IQuantityNumberProps {
  qty: number;
  onChange: (value: number | string | undefined) => void;
  min?: number;
  max?: number;
}

const QuantityNumber = (props: IQuantityNumberProps) => {
  const { qty, min, max, onChange } = props;
  const [value, setValue] = React.useState<number>(qty);
  const timer = useRef<any>(null);

  React.useEffect(() => {
    if (!min || (min && props.qty > min)) {
      setValue(props.qty);
    }

    if (!max || (max && props.qty < max)) {
      setValue(props.qty);
    }
  }, [props.qty]);

  const onClickCountUp = () => {
    const newValue = value + 1;
    if (!max || (max && newValue <= max)) {
      setValue(newValue);

      if (onChange) {
        onChange(newValue);
      }
    }
  };
  const onClickCountDown = () => {
    const newValue = value - 1;
    if (!min || (min && newValue >= min)) {
      setValue(newValue);

      if (onChange) {
        onChange(newValue);
      }
    }
  };

  const handleOnChange = (_v: any) => {
    if (!_v) {
      _v = 0;
    }

    if (max && _v > max) {
      _v = max;
    }
    if (min && _v < min) {
      _v = min;
    }

    if ((!min || (min && _v >= min)) && (!max || (max && _v <= max))) {
      setValue(_v);

      if (timer && timer.current) {
        clearTimeout(timer.current);
      }

      if (onChange) {
        timer.current = setTimeout(() => onChange(_v), 1000);
      }
    }
  };

  return (
    <div className="kd-qty-container">
      <div className="kd-qty-wrapper">
        <Input
          type={"number"}
          defaultValue={value}
          value={value}
          onChange={(e) => handleOnChange(e.target.value)}
          className={"kd-qty-input"}
          addonAfter={
            <Button
              className="qty-count-up"
              disabled={max != undefined && max != null && max == value}
              onClick={() => onClickCountUp()}>
              +
            </Button>
          }
          addonBefore={
            <Button
              className="qty-count-down"
              disabled={min != undefined && min != null && min == value}
              onClick={() => onClickCountDown()}>
              -
            </Button>
          }
        />
      </div>
    </div>
  );
};

export default QuantityNumber;
